import { minBy } from "lodash-es";

import type { MappedServiceData } from "@/app/ui/flight-purchase/AdditionalServicesSelection/types";
import type { GetFlightAvailabilityTokenAdditionalService } from "@/types/codegen";
import { type Traveller } from "@/types/types";

import type { AdditionalServiceData } from "../context/FlightSelectionPayloadContext/FlightSelectionPayloadContext";

import { getTravelerPassengerTypeCode } from "./transformTraveler";

type GetAvailableServicesParams = {
  traveller: Traveller;
  travellerIndex: number | null;
  optionalServices: GetFlightAvailabilityTokenAdditionalService[] | undefined;
  mandatoryServices: GetFlightAvailabilityTokenAdditionalService[] | undefined;
};

export const getAvailableServices = ({
  traveller,
  travellerIndex,
  optionalServices,
  mandatoryServices,
}: GetAvailableServicesParams) => {
  return [
    ...(optionalServices || []).map((service) => ({
      service,
      mandatory: false,
    })),
    ...(mandatoryServices || []).map((service) => ({
      service,
      mandatory: true,
    })),
  ].filter(
    ({ service }) =>
      !service.included &&
      Number(service.passengerIndex) === travellerIndex &&
      service.target === getTravelerPassengerTypeCode(traveller),
  );
};

export const getCheapestMandatoryServices = (services: MappedServiceData[]) => {
  return services.reduce((acc, { service, mandatory }) => {
    if (!mandatory) {
      return acc;
    }

    const cheapestOption = minBy(
      service.options,
      (option) => option.price.amount,
    );

    if (!cheapestOption) {
      return acc;
    }

    return [
      ...acc,
      {
        service: {
          bookingCode: service.bookingCode,
          selectedOptionCode: cheapestOption.code,
        },
        mandatory,
      },
    ];
  }, [] as AdditionalServiceData[]);
};
